<template>
  <div id="frequencyResponseFunction" class="animated fadeIn h-100">
    <b-row class="h-100">
      <div id="Loader" v-if="LoadYn">
        <div class="spinner-bar">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <b-col style="flex: 0 0 20%; max-width: 20%" class="tree pr20">
        <b-card
          class="h-100 black-border1"
          body-class="h-100 p10"
          header-tag="header"
        >
          <h6
            slot="header"
            class="searchBox"
            style="justify-content: space-between; padding: 0"
          >
            차트 조회 옵션
            <div>
              <b-button
                class="resetBtn w35 py5 px0"
                :class="{ 'pulse-animation': !hasConfigData && search.stid !== null }"
                style="border-radius: 5px; margin-top: 5px"
                @click="openSetting"
                :disabled="search.stid === null"
                ><i class="fas fa-cog mr0"></i
              ></b-button>
            </div>
          </h6>
          <b-form @submit.prevent="getData" class="chartOptions">
            <b-row>
              <b-col>
                <label>프로젝트</label>
                <vue-select
                  class="select-container w200"
                  v-model="search.projectid"
                  :options="search.projectOptions"
                  @input="getStidList"
                  :reduce="(a) => a.value"
                  label="text"
                  :clearable="false"
                  required
                >
                </vue-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>구조물</label>
                <vue-select
                  class="select-container w200"
                  v-model="search.stid"
                  :options="search.stidOptions"
                  :reduce="(a) => a.value"
                  label="text"
                  :clearable="false"
                  required
                >
                </vue-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>시작 일자</label>
                <b-form-input
                  type="date"
                  v-model="search.startDate"
                  :max="search.endDate"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>종료 일자</label>
                <b-form-input
                  type="date"
                  v-model="search.endDate"
                  :min="search.startDate"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <div class="btnGrp">
              <div class="jcse">
                <b-button
                  class="full-searchBtn"
                  type="submit"
                  :disabled="!isSearchEnabled || search.btnDisabled"
                  >조회</b-button
                >
              </div>
            </div>
          </b-form>
        </b-card>
      </b-col>
      <b-col style="flex: 0 0 80%; max-width: 80%" class="cont">
        <b-row class="h-100 contentarea">
          <b-col class="col-12">
            <b-card class="h-100 border0" body-class="h-100 p20">
              <b-row class="h-30 pb10">
                <b-col class="col-12">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">주파수 영역 FRF 기반 구조물 분석</h6>
                    <div id="frfChart" class="graph"></div>
                  </b-card>
                </b-col>
              </b-row>
              <b-row class="h-70 pt10">
                <b-col class="col-12">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header" class="d-flex justify-content-center align-items-center position-relative">
                      <span>상세 이력</span>
                      <b-dropdown
                        variant="link"
                        toggle-class="text-decoration-none p-0 d-flex align-items-center"
                        no-caret
                        right
                        class="position-absolute"
                        style="right: 0; top: 50%; transform: translateY(-50%);"
                      >
                        <template #button-content>
                          <i class="fas fa-ellipsis-v" style="color: #b4b7bd; font-size: 18px;"></i>
                        </template>
                        <b-dropdown-item 
                          @click="downloadExcel"
                          :disabled="!hasGridData"
                        >
                          <i class="fas fa-file-excel mr-2"></i> Excel Download
                        </b-dropdown-item>
                      </b-dropdown>
                    </h6>
                    <ag-grid-vue
                      class="ag-theme-balham grid"
                      :gridOptions="gridOptions"
                    ></ag-grid-vue>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-modal
      id="frequencyResponseFunctionModal"
      title="구조물 가속도 설정 정보"
      title-tag="h5"
      header-class="jcc"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <frequency-response-function-modal
        :stid="search.stid"
        :structureName="getStructureName"
        :configData="configData"
        @setConfigInfo="getConfigInfo"
      ></frequency-response-function-modal>
    </b-modal>
    <b-modal
      id="frequencyResponseFunctionDetailModal"
      :title="detailModalTitle"
      title-tag="h5"
      header-class="jcc position-relative"
      centered
      hide-footer
      @hidden="onDetailModalHidden"
      dialog-class="frf-detail-modal-dialog"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title w-100 text-center">{{ detailModalTitle }}</h5>
        <b-dropdown
          variant="link"
          toggle-class="text-decoration-none p-0 d-flex align-items-center"
          no-caret
          right
          class="position-absolute"
          style="right: 50px; top: 50%; transform: translateY(-50%);"
        >
          <template #button-content>
            <i class="fas fa-ellipsis-v" style="color: #b4b7bd; font-size: 18px;"></i>
          </template>
          <b-dropdown-item 
            @click="downloadDetailModalExcel"
            :disabled="!hasDetailModalChartData"
          >
            <i class="fas fa-file-excel mr-2"></i> Excel Download
          </b-dropdown-item>
        </b-dropdown>
        <button type="button" class="close" @click="close()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <frequency-response-function-detail-modal
        ref="detailModal"
        :rowData="selectedRowData"
        @chart-data-updated="onDetailModalChartDataUpdated"
      ></frequency-response-function-detail-modal>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
import FrequencyResponseFunctionModal from "./FrequencyResponseFunctionModal";
import FrequencyResponseFunctionDetailModal from "./FrequencyResponseFunctionDetailModal";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { AgGridVue } from "ag-grid-vue";
import btnRenderer from "../common/cellBtnRenderer";
import utils from "../common/utils";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  components: {
    FrequencyResponseFunctionModal,
    FrequencyResponseFunctionDetailModal,
    VueSelect,
    AgGridVue,
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "getUserAuth",
      "getAlertOptions",
      "getSelectedDataProjectid",
      "getSelectedDataStid",
      "getSelectedDataStartDate",
      "getSelectedDataEndDate",
      "getCenterBus",
    ]),
    isSearchEnabled() {
      return (
        this.search.projectid !== null &&
        this.search.stid !== null &&
        this.configData.trigger !== null &&
        this.configData.trigger !== undefined
      );
    },
    getStructureName() {
      if (!this.search.stid || !this.search.stidOptions) {
        return "구조물";
      }
      const structureOption = this.search.stidOptions.find(
        (opt) => opt.value === this.search.stid
      );
      return structureOption && structureOption.text ? structureOption.text : "구조물";
    },
    hasGridData() {
      return this.gridRowData && this.gridRowData.length > 0;
    },
    hasDetailModalChartData() {
      return this.detailModalHasChartData;
    },
  },
  watch: {
    "search.projectid"() {
      if (!this.search.projectid) {
        this.search.stid = null;
        this.hasConfigData = false;
        this.configData = {
          trigger: null,
          btm: null,
          atm: null,
          rmf: null,
          rmfMm: null,
          grDvId: null,
          stDvId: null,
          tAxis: null,
          ampl: null,
        };
      }
    },
    "search.stid"() {
      if (this.search.stid) {
        this.getConfigInfo();
      } else {
        this.hasConfigData = false;
        this.configData = {
          trigger: null,
          btm: null,
          atm: null,
          rmf: null,
          rmfMm: null,
          grDvId: null,
          stDvId: null,
          tAxis: null,
          ampl: null,
        };
      }
    },
  },
  data() {
    return {
      configData: {
        trigger: null,
        btm: null,
        atm: null,
        rmf: null,
        rmfMm: null,
        grDvId: null,
        stDvId: null,
        tAxis: null,
        ampl: null,
      },
      search: {
        projectid: null,
        projectOptions: [{ value: null, text: "선택" }],
        stid: null,
        stidOptions: [{ value: null, text: "선택" }],
        startDate: null,
        endDate: null,
        btnDisabled: false,
      },
      hasConfigData: false,
      LoadYn: false,
      isFirstCall: true,
      selectedRowData: {},
      detailModalTitle: "상세보기",
      gridRowData: [],
      detailModalHasChartData: false,
      gridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회된 데이터가 없습니다." },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        suppressHorizontalScroll: false,
        enableColResize: true,
        onGridReady: (params) => {
        },
        onRowDataChanged: (params) => {
        },
        enableSorting: true,
        rowHeight: 35,
        headerHeight: 35,
      },
    };
  },
  beforeMount() {
    this.gridOptions.columnDefs = [
      { headerName: "idx", field: "idx", hide: true },
      { headerName: "TIME (시간)", field: "analtime", width: 180 },
      { headerName: "AXIS (축)", field: "axis_label", width: 130 },
      { headerName: "F1 STRUCT (구조물 1차 주파수)", field: "f1_struct", width: 200 },
      { headerName: "구조물 디바이스", field: "structure_device", width: 200 },
      { headerName: "F1 GROUND (지반 1차 주파수)", field: "f1_ground", width: 200 },
      { headerName: "지반 디바이스", field: "ground_device", width: 200 },
      { headerName: "FRF PEAK MAGNITUDE (FRF 최대값)", field: "peak", width: 200 },
      { headerName: "COHERENCE (일관성)", field: "coherence", width: 150 },
      { headerName: "RMS", field: "rms", width: 130 },
      { headerName: "AF(증폭 계수)", field: "af", width: 130 },
      { headerName: "PGA STRUCT (구조물 최대 진폭)", field: "pga_structure", width: 200 },
      { headerName: "PGA GROUND (지반 최대 진폭)", field: "pga_ground", width: 200 },
      { headerName: "TRIGGER AXIS (트리거 축)", field: "trigger_axis", width: 200 },
      { headerName: "TRIGGER VALUE (트리거 값)", field: "trigger_value", width: 200 },
      { headerName: "TRIGGER TIME (트리거 시간)", field: "trigger_time", width: 200 },
      {
        headerName: "상세보기",
        field: "detail",
        width: 120,
        pinned: "right",
        cellRendererFramework: btnRenderer,
        cellRendererParams: {
          onClick: (rowData) => {
            this.openDetailView(rowData);
          },
          btnText: null,
          iconYn: true,
          iconClass: "fas fa-search",
          backgroundColor: "#7367f0",
          borderColor: "#7367f0",
          color: "#fff",
        },
      },
    ];
  },
  created() {
    this.getProjectList();
    if (this.getSelectedDataStid) {
      this.search.stid = this.getSelectedDataStid;
    }
  },
  mounted() {
    this.search.startDate = moment().subtract(7, 'days').format("YYYY-MM-DD");
    this.search.endDate = moment().format("YYYY-MM-DD");
  },
  methods: {
    ...mapMutations([
      "setAlertTitle",
      "setSelectedDataProjectid",
      "setSelectedDataStid",
      "setSelectedDataStartDate",
      "setSelectedDataEndDate",
    ]),
    openSetting() {
      this.$bvModal.show("frequencyResponseFunctionModal");
    },
    getProjectList() {
      var reqBody = {};
      this.$http
        .post("/stat/getProjectListAll", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            const projst = {
              PRE: "(준비중)",
              SVC: "",
              IDL: "(휴면)",
              EXP: "(종료)",
            };
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].projectid,
                text: data[i].projectname + projst[data[i].projstate],
              });
            }
            this.search.projectOptions = options;
            if (this.getSelectedDataProjectid) {
              this.search.projectid = this.getSelectedDataProjectid;
              this.getStidList();
            } else this.search.projectid = null;
          } else {
            this.setAlertTitle("프로젝트 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getStidList() {
      if (!this.search.projectid) {
        this.search.stidOptions = [{ value: null, text: "선택" }];
        this.search.stid = null;
        return;
      }
      var reqBody = {
        projectid: this.search.projectid,
      };
      this.$http
        .post("/sensor/getStidList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].stid,
                text: data[i].stname,
              });
            }
            this.search.stidOptions = options;
            if (this.isFirstCall) {
              if (this.getSelectedDataStid) {
                this.search.stid = this.getSelectedDataStid;
              } else this.search.stid = null;
            } else this.search.stid = null;
            this.isFirstCall = false;
          } else {
            this.setAlertTitle("구조물 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getConfigInfo() {
      let reqBody = {
        stid: this.search.stid,
      };
      this.$http
        .post("/frequencyResponseFunction/getConfigInfo", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let configInfo = res.data.data;
            if (configInfo && configInfo.T_VAL !== null && configInfo.T_VAL !== undefined) {
              this.configData.trigger = configInfo.T_VAL;
              this.configData.btm = configInfo.BTM;
              this.configData.atm = configInfo.ATM;
              this.configData.rmf = configInfo.RMF;
              this.configData.rmfMm = configInfo.RMF_MM;
              this.configData.grDvId = configInfo.GR_DV_ID;
              this.configData.stDvId = configInfo.ST_DV_ID;
              this.configData.tAxis = configInfo.T_AXIS;
              this.configData.ampl = configInfo.AMPL;
              this.hasConfigData = true;
            } else {
              this.hasConfigData = false;
              this.configData = {
                trigger: null,
                btm: null,
                atm: null,
                rmf: null,
                rmfMm: null,
                grDvId: null,
                stDvId: null,
                tAxis: null,
                ampl: null,
              };
            }
          } else {
            this.hasConfigData = false;
            this.configData = {
              trigger: null,
              btm: null,
              atm: null,
              rmf: null,
              rmfMm: null,
              grDvId: null,
              stDvId: null,
              tAxis: null,
              ampl: null,
            };
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getData() {
      if (this.search.projectid === null) {
        this.setAlertTitle("프로젝트를 선택해주세요.");
        this.$bvModal
          .msgBoxOk("프로젝트를 선택해주세요.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
        return;
      }
      if (this.search.stid === null) {
        this.setAlertTitle("구조물을 선택해주세요.");
        this.$bvModal
          .msgBoxOk("구조물을 선택해주세요.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
        return;
      }

      var reqBody = {
        stid: this.search.stid,
        startDate: moment(this.search.startDate).format("YYYYMMDD"),
        endDate: moment(this.search.endDate).format("YYYYMMDD"),
      };

      this.setSelectedDataProjectid(this.search.projectid);
      this.setSelectedDataStid(this.search.stid);
      this.setSelectedDataStartDate(this.search.startDate);
      this.setSelectedDataEndDate(this.search.endDate);

      this.search.btnDisabled = true;
      this.LoadYn = true;

      this.$http
        .post("/frequencyResponseFunction/getAnalysisData", reqBody, {
          timeout: 600000,
        })
        .then((res) => {
          this.search.btnDisabled = false;
          this.LoadYn = false;

          if (res.data.resultyn === "Y") {
            if (
              res.data.data.error_msg != null &&
              res.data.data.error_msg.length > 0
            ) {
              this.initChartAndGrid();
              this.setAlertTitle();
              this.$bvModal
                .msgBoxOk(res.data.data.error_msg, this.getAlertOptions)
                .then((value) => {})
                .catch((err) => {
                  console.error(err);
                });
              return;
            }

            let resData = res.data.data;
            if (!resData || !Array.isArray(resData) || resData.length === 0) {
              this.initChartAndGrid();
              return;
            }

            const time = resData.map((item) => item.analtime || "").filter((t) => t !== "");

            this.drawChart(time);
            this.gridRowData = resData;
            this.gridOptions.api.setRowData(resData);
          } else {
            this.initChartAndGrid();
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          this.search.btnDisabled = false;
          this.LoadYn = false;
          this.initChartAndGrid();
          console.error(err);
        });
    },
    drawChart(time) {
      if (!time || time.length === 0) return;

      const structureOption = this.search.stidOptions.find(
        (opt) => opt.value === this.search.stid
      );
      const structureName = structureOption && structureOption.text ? structureOption.text : "구조물";

      const xData = time.map((t) => {
        if (typeof t === 'string') {
          const date = moment(t, 'YYYY-MM-DD HH:mm:ss');
          return date.isValid() ? date.valueOf() : t;
        }
        return t;
      });

      const yData = new Array(time.length).fill(0);

      const chartData = [
        {
          x: xData,
          y: yData,
          mode: "markers",
          type: "scatter",
          marker: {
            size: 10,
            color: "#7367f0",
            symbol: "circle",
          },
          name: structureName,
        },
      ];

      const layout = {
        title: "",
        xaxis: {
          title: "시간",
          showgrid: true,
          gridcolor: "#404656",
          type: time.length > 0 && typeof time[0] === 'string' ? 'date' : 'linear',
        },
        yaxis: {
          title: structureName,
          showgrid: true,
          gridcolor: "#404656",
          fixedrange: true,
          tickmode: 'array',
          tickvals: [0],
          ticktext: [structureName],
        },
        plot_bgcolor: "#283046",
        paper_bgcolor: "#283046",
        font: {
          color: "#b4b7bd",
        },
        margin: {
          l: 100,
          r: 50,
          t: 30,
          b: 50,
        },
        showlegend: false,
      };

      const config = {
        displayModeBar: false,
        responsive: true,
      };

      Plotly.newPlot("frfChart", chartData, layout, config);
    },
    initChartAndGrid() {
      try {
        Plotly.purge("frfChart");
      } catch (err) {
        console.error("차트 초기화 오류:", err);
      }
      
      this.gridRowData = [];
      if (this.gridOptions && this.gridOptions.api) {
        try {
          this.gridOptions.api.setRowData([]);
        } catch (err) {
          console.error("그리드 초기화 오류:", err);
        }
      }
    },
    openDetailView(rowData) {
      this.selectedRowData = rowData || {};
      const analtime = (rowData && rowData.analtime) ? rowData.analtime : "";
      const axis = (rowData && rowData.axis_label) ? rowData.axis_label : "";
      // this.detailModalTitle = `시간 : ${analtime}   축 : ${axis}`;
      this.detailModalTitle = 'FRF 분석 상세 결과';
      this.$bvModal.show("frequencyResponseFunctionDetailModal");
    },
    onDetailModalHidden() {
      this.selectedRowData = {};
      this.detailModalHasChartData = false;
    },
    onDetailModalChartDataUpdated(hasData) {
      this.detailModalHasChartData = hasData;
    },
    downloadDetailModalExcel() {
      if (this.$refs.detailModal && this.$refs.detailModal.downloadExcel) {
        this.$refs.detailModal.downloadExcel();
      }
    },
    downloadExcel() {
      if (!this.hasGridData || !this.gridRowData || this.gridRowData.length === 0) {
        this.setAlertTitle("데이터가 없습니다.");
        this.$bvModal
          .msgBoxOk("다운로드할 데이터가 없습니다.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
        return;
      }

      this.LoadYn = true;
      
      const visibleColumns = this.gridOptions.columnDefs.filter(col => !col.hide && col.field !== 'detail');
      const header = visibleColumns.map(col => col.headerName);
      
      const content = {};
      visibleColumns.forEach(col => {
        content[col.headerName] = this.gridRowData.map(row => row[col.field] || '');
      });

      const contents = [{
        sheetName: "FRF 상세 이력",
        header: header,
        content: content
      }];

      const startDate = moment(this.search.startDate).format("YYYYMMDD");
      const endDate = moment(this.search.endDate).format("YYYYMMDD");
      const structureName = this.getStructureName.replace(/[^a-zA-Z0-9가-힣]/g, "_");
      const fileName = `FRF_상세이력_${startDate}_${endDate}_${structureName}`;

      const reqBody = {
        fileName: fileName,
        data: contents
      };

      this.$http
        .post("/frequencyResponseFunction/excelDownload", reqBody, {
          responseType: "arraybuffer",
          timeout: 180000,
        })
        .then((res) => {
          this.LoadYn = false;
          utils.getExcelFile(res, null, fileName);
        })
        .catch((err) => {
          this.LoadYn = false;
          console.error(err);
          this.setAlertTitle("엑셀 다운로드 실패");
          this.$bvModal
            .msgBoxOk("엑셀 다운로드 중 오류가 발생했습니다.", this.getAlertOptions)
            .then((value) => {})
            .catch((error) => {
              console.error(error);
            });
        });
    },
  },
};
</script>

<style lang="scss">
#frequencyResponseFunction {
  padding: 15px;
  & .chartOptions {
    & .row {
      height: 50px;
      & .col {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 0;
        & label {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          color: #b4b7bd;
          width: 100px;
          height: 100%;
          margin-bottom: 0;
        }
        & input,
        & select {
          width: 200px;
        }
      }
    }
  }
  .select-container {
    .vs__dropdown-toggle {
      width: 100%;
      height: 35px;
      margin-right: 0px;
    }
    .vs__search::placeholder {
      color: #b4b7bd !important;
    }
  }
  & .contentarea {
    & .card {
      & .card-header {
        padding: 6px 15px 8px;
        border-bottom: 1px solid #404656;
        position: relative;
        z-index: 10;
        & h6 {
          font-size: 15px;
          line-height: unset;
          justify-content: center;
        }
      }
      & .card-body {
        & .graph {
          height: 100%;
        }
      }
    }
    & div.ag-theme-balham.grid {
      height: 100% !important;
      font-size: 13px !important;
      & .ag-root .ag-body .ag-body-viewport {
        overflow-x: auto;
      }
      & .ag-header-cell-text,
      & .ag-cell {
        font-size: 13px !important;
      } 
    }
  }
  & .pulse-animation {
    animation: pulse 2s ease-in-out infinite;
  }
  
  & .dropdown {
    z-index: 1050;
    
    & .dropdown-toggle::after {
      display: none;
    }
  }
  
  & .dropdown-menu {
    background-color: #283046;
    border: 1px solid #404656;
    min-width: 180px;
    z-index: 1051 !important;
    position: absolute !important;
    
      & .dropdown-item {
      color: #b4b7bd;
      padding: 8px 16px;
      
      &:hover:not(.disabled) {
        background-color: #404656;
        color: #fff;
      }
      
      &:active:not(.disabled) {
        background-color: #7367f0;
        color: #fff;
      }
      
      &.disabled,
      &[disabled] {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
        color: #6c757d !important;
      }
      
      & i {
        width: 20px;
      }
    }
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(115, 103, 240, 0.7);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(115, 103, 240, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(115, 103, 240, 0);
  }
}

.frf-detail-modal-dialog {
  max-width: 1800px !important;
  width: 1800px !important;
  
  & .modal-content {
    height: 900px !important;
    
    & .modal-header {
      position: relative;
      
      & .modal-title {
        margin: 0;
      }
      
      & .dropdown {
        z-index: 1050;
        
        & .dropdown-toggle::after {
          display: none;
        }
      }
      
      & .dropdown-menu {
        background-color: #283046;
        border: 1px solid #404656;
        min-width: 180px;
        z-index: 1051 !important;
        position: absolute !important;
        
        & .dropdown-item {
          color: #b4b7bd;
          padding: 8px 16px;
          
          &:hover:not(.disabled) {
            background-color: #404656;
            color: #fff;
          }
          
          &:active:not(.disabled) {
            background-color: #7367f0;
            color: #fff;
          }
          
          &.disabled,
          &[disabled] {
            opacity: 0.5;
            cursor: not-allowed;
            pointer-events: none;
            color: #6c757d !important;
          }
          
          & i {
            width: 20px;
          }
        }
      }
    }
    
    & .modal-body {
      height: calc(100% - 120px) !important;
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/analysis/FrequencyResponseFunction.vue